import React, { useState } from 'react'
import { validateEmail, validateName, validateTel, validatePassword, validatePasswordCheck, validateRequire } from '../../../utils/validation/validation'
import { login_msg, signup_msg } from '../../../utils/msg/msg'
import { checkIdDuplicationApi, sendCertificationEmailApi, signupApi, verifyCertificationCodeApi } from '../../../api/user'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { swalErrorAlert } from '../../../utils/swal/swal'

const Signup = () => {

    /* Navigate */
    const navigate = useNavigate()

    /* State */

    // element
    const [emailInput, setEmailInput] = useState('')
    const [cetificationInput, setCetificationInput] = useState('')
    const [nameInput, setNameInput] = useState('')
    const [telInput, setTelInput] = useState('')
    const [passwordInput, setPasswordInput] = useState('')
    const [passwordCheckInput, setPasswordCheckInput] = useState('')

    // error
    const [emailError, setEmailError] = useState('')
    const [nameError, setNameError] = useState('')
    const [telError, setTelError] = useState('')
    const [passwordError, setPasswordError] = useState('')


    // 메일전송여부
    const [isMailSuccess, setIsMailSuccess] = useState(false)

    // 인증여부 
    const [certificationMessageState, setCertificationMessageState] = useState('') // 'success' / 'fail' / 'invalid' / 'expired'
    const [isCertification, setIsCertification] = useState(false)


    /* Methods */
    const onSubmitForm = async (e) => {
        e.preventDefault()

        // 유효성검사
        let isValidate = true;
        if (emailInput.trim() === '' || !validateEmail(emailInput)) {
            setEmailError(login_msg.emailError)
            isValidate = false
        }

        if (cetificationInput.trim() === '' || !validateRequire(cetificationInput)) {
            setCertificationMessageState('invalid')
            isValidate = false
        }

        if (!validateName(nameInput)) {
            setNameError(login_msg.nameError)
            isValidate = false
        }

        if (!validateTel(telInput)) {
            setTelError(login_msg.telError)
            isValidate = false
        }

        if (passwordInput.trim() === '' || !validatePassword(passwordInput)) {
            setPasswordError(login_msg.passwordError)
            isValidate = false
        } else if (passwordInput.trim() !== passwordCheckInput.trim()) {
            setPasswordError(login_msg.passwordCheckError)
            isValidate = false
        }

        // 이메일 인증여부 검사
        if (!isCertification) {
            setCertificationMessageState('fail')
            isValidate = false
        }
        if (!isValidate) return


        // API 요청
        try {
            const requestData = {
                email: emailInput,
                code: cetificationInput,
                name: nameInput,
                tel: telInput,
                password: passwordInput,
                passwordCheck: passwordCheckInput
            }
            await signupApi(requestData)

            Swal.fire({
                title: "회원가입 성공",
                html: "회원가입이 성공적으로 완료되었습니다.",
                icon: "success",
                confirmButtonText: "확인",
            }).then(() => {
                navigate('/login')
                return
            })

        } catch (error) {
            swalErrorAlert("회원가입 실패", "회원가입 처리 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.", '', '')
            return

        }
    }

    /* Func : 인증코드 메일 전송 */
    const onClickSendCertificationMail = async () => {
        // 유효성검사
        let isValidate = true;
        if (emailInput.trim() === '' || !validateEmail(emailInput)) {
            setEmailError(login_msg.emailError)
            isValidate = false
        }
        if (!isValidate) { return false };

        // API 요청
        try {
            const requestData = { email: emailInput }

            await checkIdDuplicationApi(requestData) // 아이디 중복확인
            await sendCertificationEmailApi(requestData) // 메일 발송

            Swal.fire({
                title: "인증번호 전송",
                html: "인증번호가 이메일로 전송되었습니다.<br/> 6자리 인증번호를 입력해주세요.",
                icon: "success",
                confirmButtonText: "확인",
            }).then(() => {
                setIsMailSuccess(true)
            })
            return

        } catch (error) {
            // console.log(error);

            // 이미 사용중인 아이디
            if (error.status === 409) {
                const error_msg = error?.response?.data?.message
                if (error_msg) {
                    setEmailError(error_msg)
                    return
                }
            } else {
                swalErrorAlert("메일 전송 실패", "인증번호 메일 전송 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.", '', '')
                return
            }

        }
    }

    /* Func : 인증코드 검사 */
    const onClickCertificationCode = async () => {
        // 유효성검사
        if (cetificationInput.length !== 6) {
            setCertificationMessageState('invalid')
            return
        }

        // API요청
        try {
            const requestData = { email: emailInput, code: cetificationInput }
            await verifyCertificationCodeApi(requestData)

            // 성공
            setCertificationMessageState('success')
            setIsCertification(true)

        } catch (error) {
            // console.log(error);
            setIsCertification(false)

            if (error.status === 400) {
                // 인증번호 틀림
                setCertificationMessageState('fail')
                return
            }
            else if (error.status === 410) {
                // 인증번호 만료
                setCertificationMessageState('expired')
                return
            }
            else {
                swalErrorAlert("인증 실패", "인증번호 인증 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.", "error", "확인")
                return
            }
        }
    }

    return (
        <div className='signup'>
            <div className='mb-5 text-center'>
                <h2 className="h2 mb-3 fw-normal">회원가입</h2>
            </div>

            <form onSubmit={onSubmitForm}>
                {/* 이메일 */}
                <div className="row gx-3 gy-2 mb-4">
                    <div className="col-sm-8">
                        <label htmlFor="email" className="form-label">이메일</label>
                        <input
                            type="text"
                            name="email"
                            id="email"
                            className="form-control"
                            value={emailInput}
                            onChange={e => {
                                setEmailInput(e.target.value)
                                validateEmail(e.target.value) ? setEmailError('') : setEmailError(login_msg.emailError)
                            }}
                            disabled={isMailSuccess || isCertification}
                            placeholder="이메일을 입력해주세요"
                        />
                    </div>
                    <div className="col-sm-4 align-self-end">
                        <button
                            type='button'
                            className='btn btn-outline-primary w-100'
                            onClick={onClickSendCertificationMail}
                            disabled={isCertification}
                        >인증번호 전송</button>
                    </div>
                    {emailError && <p className="small text-danger mx-2">{emailError}</p>}

                    {/* 인증 */}
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="인증번호 6자리를 입력해주세요"
                            value={cetificationInput}
                            maxLength={6}
                            onChange={e => {
                                let value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
                                setCetificationInput(value)

                                if (value.length === 6) { setCertificationMessageState('') }
                                else { setCertificationMessageState('invalid') }
                            }}
                            disabled={!isMailSuccess || isCertification}
                        />
                    </div>
                    <div className="col-sm-4 text-end">
                        <button
                            type='button'
                            className='btn btn-outline-primary w-100'
                            onClick={onClickCertificationCode}
                            disabled={!isMailSuccess || isCertification}
                        >인증하기</button>
                    </div>
                    {certificationMessageState === 'success' && <p className="small text-success mx-2">{signup_msg.certificationSuccess}</p>}
                    {certificationMessageState === 'fail' && <p className="small text-danger mx-2">{signup_msg.certificationFail}</p>}
                    {certificationMessageState === 'invalid' && <p className="small text-danger mx-2">{signup_msg.certificationInValid}</p>}
                    {certificationMessageState === 'expired' && <p className="small text-danger mx-2">{signup_msg.certificationExpired}</p>}

                    <div className="col-sm-12 text-end">
                        <span className='mail-retry small text-decoration-underline text-secondary' onClick={onClickSendCertificationMail}>인증번호 재전송</span>
                    </div>
                </div>

                {/* 이름 */}
                <div className="row gx-3 gy-2 mb-4">
                    <div className="col-12">
                        <label htmlFor="userName" className="form-label">이름</label>
                        <input
                            type="text"
                            name="userName"
                            id="userName"
                            className="form-control"
                            value={nameInput}
                            maxLength={40}
                            onChange={(e) => {
                                setNameInput(e.target.value)
                                validateName(e.target.value) ? setNameError('') : setNameError(login_msg.nameError)
                            }}
                            placeholder="이름을 입력해주세요"
                        />
                    </div>
                    {nameError && <p className="small text-danger mx-2">{nameError}</p>}
                </div>

                {/* 휴대전화번호 */}
                <div className="row gx-3 gy-2 mb-4">
                    <div className="col-12">
                        <label htmlFor="userTel" className="form-label">휴대전화번호(-제외)</label>
                        <input
                            type="text"
                            name="userTel"
                            id="userTel"
                            className="form-control"
                            value={telInput}
                            maxLength={11}
                            onChange={(e) => {
                                let v = e.target.value.replace(/[^0-9]/g, '')
                                setTelInput(v)
                                validateTel(v) ? setTelError('') : setTelError(login_msg.telError)
                            }}
                            placeholder="휴대전화번호를 입력해주세요"
                        />
                    </div>

                    {telError && <p className="small text-danger mx-2">{telError}</p>}
                </div>

                <div className="row gx-3 gy-2">
                    {/* 비밀번호 */}
                    <div className="col-sm-12">
                        <label htmlFor="password" className="form-label">비밀번호</label>
                        <input
                            type="password"
                            name="password"
                            id="password"
                            className="form-control"
                            value={passwordInput}
                            onChange={(e) => {
                                setPasswordInput(e.target.value)
                                setPasswordError(validatePassword(e.target.value) ? '' : login_msg.passwordError)
                            }}
                            placeholder="8자리 이상 비밀번호를 입력해주세요"
                        />
                    </div>

                    <div className="col-sm-12">
                        <input
                            type="password"
                            name="passwordCheck"
                            className="form-control"
                            value={passwordCheckInput}
                            onChange={(e) => {
                                setPasswordCheckInput(e.target.value)
                                setPasswordError(validatePasswordCheck(e.target.value, passwordInput) ? '' : login_msg.passwordCheckError)
                            }}
                            placeholder="비밀번호 확인"
                        />
                    </div>

                    {passwordError && <p className="small text-danger mx-2">{passwordError}</p>}
                </div>

                <hr className="my-4" />

                {/* 약관동의 */}
                {/* <div className="form-check">
                    <input type="checkbox" className="form-check-input" id="same-address" />
                    <label className="form-check-label" htmlFor="same-address">회원가입 약관 동의</label>
                </div>
                <hr className="my-4" /> */}

                <button className="w-100 btn btn-primary btn-lg" type="submit">가입하기</button>
            </form>
        </div>

    )
}

export default Signup